;(() => {
  const CONFIG = window.NEOX_AI_CHAT_CONFIG || {};
  const API_BASE = CONFIG.apiBase || "";
  const SESSION_KEY = "neox_ai_chat_session_id";
  const sessionId = localStorage.getItem(SESSION_KEY) || ("nx_" + Date.now() + "_" + Math.random().toString(16).slice(2));
  localStorage.setItem(SESSION_KEY, sessionId);
  const isTestPath = location.pathname === "/pages/double-sided-lightbox" || location.pathname.indexOf("/pages/double-sided-lightbox-ai-") === 0;
  if (!isTestPath) return;
  const chatState = { lastIntent: null, lastFamily: null, pending: null, destination: null, selectedSize: null, quantity: null };
  let lastBehaviorTrigger = "customer_message";

  const sourceContext = () => {
    const params = new URLSearchParams(location.search || "");
    return {
      page: location.href,
      page_url: location.href,
      landing_page: location.pathname,
      referrer: document.referrer || "",
      device: window.innerWidth <= 640 ? "mobile" : "desktop",
      locale: navigator.language || "",
      utm_source: params.get("utm_source") || "",
      utm_medium: params.get("utm_medium") || "",
      utm_campaign: params.get("utm_campaign") || "",
      product: "Double-Sided Fabric Light Box",
      triggered_by: lastBehaviorTrigger
    };
  };

  const postEvent = (eventType, payload) => {
    if (!API_BASE) return;
    try {
      fetch(API_BASE.replace(/\/$/, "") + "/api/events", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          session_id: sessionId,
          event_type: eventType,
          page_url: location.href,
          context: sourceContext(),
          payload: payload || {}
        }),
        keepalive: true
      }).catch(() => {});
    } catch (e) {}
  };

  const fetchBackendAnswer = async (message) => {
    if (!API_BASE) return null;
    const controller = typeof AbortController !== "undefined" ? new AbortController() : null;
    const timer = controller ? setTimeout(() => controller.abort(), 5200) : null;
    try {
      const response = await fetch(API_BASE.replace(/\/$/, "") + "/chat", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          session_id: sessionId,
          message,
          page_url: location.href,
          context: sourceContext()
        }),
        signal: controller ? controller.signal : undefined
      });
      if (!response.ok) return null;
      const data = await response.json();
      if (!data || !Array.isArray(data.replies) || !data.replies.length) return null;
      return data;
    } catch (e) {
      return null;
    } finally {
      if (timer) clearTimeout(timer);
    }
  };

  postEvent("page_view", { title: document.title || "", fallback: true });

  const behaviorSent = {};
  const trackBehavior = (name, payload) => {
    if (behaviorSent[name]) return;
    behaviorSent[name] = true;
    lastBehaviorTrigger = name;
    postEvent(name, payload || {});
  };
  setTimeout(() => trackBehavior("proactive_dwell_product", { seconds: 20, fallback: true }), 20000);
  const elementInView = (el) => {
    if (!el || !el.getBoundingClientRect) return false;
    const rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight * 0.82 && rect.bottom > window.innerHeight * 0.18;
  };
  const checkFocusAreas = () => {
    const specEl = document.querySelector("[id*='spec' i], [class*='spec' i], [id*='overview' i], [class*='overview' i]");
    const quoteEl = document.querySelector("[id*='quote' i], [class*='quote' i], [href*='quote' i], [id*='nxpl-quote' i]");
    if (elementInView(specEl)) trackBehavior("proactive_spec_focus", { area: "spec", fallback: true });
    if (elementInView(quoteEl)) trackBehavior("proactive_quote_focus", { area: "quote", fallback: true });
  };
  window.addEventListener("scroll", () => {
    window.requestAnimationFrame ? window.requestAnimationFrame(checkFocusAreas) : setTimeout(checkFocusAreas, 0);
  }, { passive: true });
  setTimeout(checkFocusAreas, 2500);
  document.addEventListener("mouseleave", (event) => {
    if (event.clientY <= 0) trackBehavior("proactive_exit_intent", { fallback: true, device: window.innerWidth <= 640 ? "mobile" : "desktop" });
  });
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") trackBehavior("proactive_exit_intent", { fallback: true, via: "visibilitychange" });
  });

  const hideLegacyFloating = () => {
    const selector = [
      ".nxpl-floating",
      ".nxpl-float",
      ".neox-lite-whatsapp-float",
      "a[href*='wa.me']",
      "a[href*='whatsapp']"
    ].join(",");
    document.querySelectorAll(selector).forEach((el) => {
      if (el.closest && el.closest("#neox-ai-chat")) return;
      const cls = String(el.className || "").toLowerCase();
      const href = String(el.getAttribute("href") || "").toLowerCase();
      const aria = String(el.getAttribute("aria-label") || "").toLowerCase();
      if (cls.includes("nxpl-floating") || cls.includes("nxpl-float") || cls.includes("neox-lite-whatsapp-float") || href.includes("wa.me") || href.includes("whatsapp") || aria.includes("whatsapp")) {
        el.setAttribute("data-neox-ai-hidden", "true");
        el.style.setProperty("display", "none", "important");
        el.style.setProperty("visibility", "hidden", "important");
        el.style.setProperty("opacity", "0", "important");
        el.style.setProperty("pointer-events", "none", "important");
      }
    });
  };

  const ensureStyles = () => {
    if (document.getElementById("neox-ai-chat-fallback-v1-style")) return;
    const style = document.createElement("style");
    style.id = "neox-ai-chat-fallback-v1-style";
    style.textContent = [
      "[data-neox-ai-hidden='true']{display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important}",
      ".nxpl-floating,.nxpl-float,.neox-lite-whatsapp-float{display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important}",
      "#neox-ai-chat{position:fixed!important;right:22px!important;bottom:24px!important;z-index:2147483000!important;font-family:Arial,sans-serif!important;color:#111827!important;width:auto!important;height:auto!important;max-width:calc(100vw - 24px)!important}",
      "#neox-ai-chat button{font:inherit!important;letter-spacing:0!important;text-transform:none!important}",
      "#neox-ai-chat .nx-chat-launch{display:flex!important;align-items:center!important;gap:9px!important;min-width:178px!important;width:auto!important;height:50px!important;border:0!important;background:#ff6a00!important;color:#fff!important;border-radius:999px!important;padding:0 18px!important;box-shadow:0 14px 34px rgba(255,106,0,.34),0 8px 22px rgba(0,0,0,.18)!important;cursor:pointer!important;font-weight:800!important;font-size:14px!important;line-height:1!important;white-space:nowrap!important}",
      "#neox-ai-chat .nx-chat-launch:before{content:'NEOX';display:inline-flex;align-items:center;justify-content:center;width:38px;height:24px;border-radius:999px;background:#111827;color:white;font-size:11px;font-weight:850}",
      "#neox-ai-chat .nx-chat-panel{width:min(380px,calc(100vw - 28px))!important;height:min(620px,calc(100vh - 36px))!important;background:white!important;border:1px solid #e5e7eb!important;border-radius:12px!important;box-shadow:0 20px 60px rgba(0,0,0,.24)!important;display:none;overflow:hidden!important}",
      "#neox-ai-chat .nx-chat-head{background:#111827!important;color:white!important;padding:14px 16px!important;display:flex!important;justify-content:space-between!important;align-items:center!important}",
      "#neox-ai-chat .nx-chat-head strong{display:block!important;font-size:15px!important}#neox-ai-chat .nx-chat-head span{font-size:12px!important;color:#d1d5db!important}",
      "#neox-ai-chat .nx-chat-close{background:transparent!important;color:white!important;border:0!important;font-size:20px!important;cursor:pointer!important}",
      "#neox-ai-chat .nx-chat-log{height:420px!important;overflow:auto!important;padding:14px!important;background:#f8fafc!important}",
      "#neox-ai-chat .nx-msg{max-width:82%!important;padding:10px 12px!important;border-radius:12px!important;margin:8px 0!important;font-size:14px!important;line-height:1.42!important}",
      "#neox-ai-chat .nx-ai{background:white!important;border:1px solid #e5e7eb!important}#neox-ai-chat .nx-user{background:#111827!important;color:white!important;margin-left:auto!important}",
      "#neox-ai-chat .nx-msg a{color:#165dff!important;font-weight:700!important;text-decoration:underline!important;word-break:break-all!important}#neox-ai-chat .nx-user a{color:#bfdbfe!important}",
      "#neox-ai-chat .nx-typing{display:flex!important;align-items:center!important;gap:5px!important;color:#6b7280!important;font-size:13px!important}#neox-ai-chat .nx-typing:before{content:'Admin NEOX sedang mengetik';margin-right:2px}#neox-ai-chat .nx-dot{width:5px;height:5px;border-radius:999px;background:#9ca3af;animation:nxTyping 1.05s infinite ease-in-out}#neox-ai-chat .nx-dot:nth-child(2){animation-delay:.14s}#neox-ai-chat .nx-dot:nth-child(3){animation-delay:.28s}@keyframes nxTyping{0%,80%,100%{opacity:.35;transform:translateY(0)}40%{opacity:1;transform:translateY(-2px)}}",
      "#neox-ai-chat .nx-choice-row{max-width:92%;display:flex!important;gap:7px!important;flex-wrap:wrap!important;margin:8px 0 10px!important}#neox-ai-chat .nx-choice{border:1px solid #cfd8e3!important;background:#fff!important;color:#111827!important;border-radius:999px!important;padding:8px 11px!important;font-size:12px!important;cursor:pointer!important;box-shadow:none!important}#neox-ai-chat .nx-choice:hover{border-color:#165dff!important;color:#165dff!important}#neox-ai-chat .nx-choice:disabled{opacity:.48!important;cursor:default!important}",
      "#neox-ai-chat .nx-quick{display:flex!important;gap:6px!important;flex-wrap:wrap!important;padding:10px 12px!important;border-top:1px solid #eee!important}",
      "#neox-ai-chat .nx-quick button{border:1px solid #d1d5db!important;background:white!important;color:#111827!important;border-radius:999px!important;padding:7px 10px!important;font-size:12px!important;cursor:pointer!important}",
      "#neox-ai-chat .nx-form{display:flex!important;gap:8px!important;padding:12px!important;border-top:1px solid #eee!important}",
      "#neox-ai-chat .nx-input{flex:1!important;border:1px solid #d1d5db!important;border-radius:8px!important;padding:10px!important;font-size:14px!important}",
      "#neox-ai-chat .nx-send{border:0!important;border-radius:8px!important;background:#111827!important;color:white!important;padding:0 14px!important;cursor:pointer!important}",
      "@media(max-width:520px){#neox-ai-chat{right:12px!important;left:12px!important;bottom:18px!important;display:flex!important;justify-content:flex-end!important}.nx-chat-launch{min-width:188px!important}.nx-chat-panel{height:calc(100vh - 56px)!important;width:calc(100vw - 24px)!important}}"
    ].join("");
    document.head.appendChild(style);
  };

  const answer = (message) => [
    "sebentar ya ka, saya bantu teruskan ke admin khusus NEOX supaya jawabannya tetap aman.",
    "kalau kaka butuh jawaban sekarang, bisa lanjut ke admin khusus NEOX."
  ];
  const mountFallback = () => {
    hideLegacyFloating();
    ensureStyles();

    const roots = Array.from(document.querySelectorAll("#neox-ai-chat"));
    let root = roots[roots.length - 1] || null;
    if (root && root.dataset.neoxFallbackReady !== "true") {
      roots.forEach((el) => el.remove());
      root = null;
    } else {
      roots.slice(0, -1).forEach((el) => el.remove());
    }
    if (!root) {
      root = document.createElement("div");
      root.id = "neox-ai-chat";
      root.innerHTML = '<button class="nx-chat-launch">Chat Admin NEOX</button><section class="nx-chat-panel"><div class="nx-chat-head"><div><strong>Admin NEOX</strong><span>Balas cepat untuk Fabric Light Box</span></div><button class="nx-chat-close">x</button></div><div class="nx-chat-log"></div><div class="nx-quick"><button data-q="Harga ukuran 60x120 berapa?">Harga 60x120</button><button data-q="Bisa cetak poster juga?">Cetak poster</button><button data-q="Ongkir ke Jakarta berapa?">Cek ongkir</button></div><form class="nx-form"><input class="nx-input" placeholder="Tulis pertanyaan kaka..." autocomplete="off"><button class="nx-send">Kirim</button></form></section>';
      document.body.appendChild(root);
    }
    window.__NEOX_AI_CHAT_LOADED__ = true;

    const launch = root.querySelector(".nx-chat-launch");
    const panel = root.querySelector(".nx-chat-panel");
    const close = root.querySelector(".nx-chat-close");
    const log = root.querySelector(".nx-chat-log");
    const form = root.querySelector(".nx-form");
    const input = root.querySelector(".nx-input");
    const sendButton = root.querySelector(".nx-send");
    if (!launch || !panel || !log || !form || root.dataset.neoxFallbackReady === "true") {
      if (launch) launch.textContent = "Chat Admin NEOX";
      return;
    }
    root.dataset.neoxFallbackReady = "true";
    launch.textContent = "Chat Admin NEOX";
    let isReplying = false;
    let typingNode = null;

    const appendLinkedText = (container, text) => {
      const source = String(text || "");
      const urlPattern = /(https?:\/\/[^\s]+)/g;
      let lastIndex = 0;
      let match;
      while ((match = urlPattern.exec(source))) {
        if (match.index > lastIndex) container.appendChild(document.createTextNode(source.slice(lastIndex, match.index)));
        let rawUrl = match[0];
        let trailing = "";
        while (/[),.;!?，。；！？）]$/.test(rawUrl)) {
          trailing = rawUrl.slice(-1) + trailing;
          rawUrl = rawUrl.slice(0, -1);
        }
        const link = document.createElement("a");
        link.href = rawUrl;
        link.target = "_blank";
        link.rel = "noopener";
        link.textContent = rawUrl;
        link.addEventListener("click", (event) => {
          postEvent("product_link_click", {
            href: event.currentTarget.href,
            label: event.currentTarget.textContent || ""
          });
        });
        container.appendChild(link);
        if (trailing) container.appendChild(document.createTextNode(trailing));
        lastIndex = match.index + match[0].length;
      }
      if (lastIndex < source.length) container.appendChild(document.createTextNode(source.slice(lastIndex)));
    };

    const add = (text, who) => {
      const div = document.createElement("div");
      div.className = "nx-msg " + (who === "user" ? "nx-user" : "nx-ai");
      appendLinkedText(div, text);
      log.appendChild(div);
      log.scrollTop = log.scrollHeight;
    };
    const addChoices = (items) => {
      const row = document.createElement("div");
      row.className = "nx-choice-row";
      items.forEach((item) => {
        const button = document.createElement("button");
        button.type = "button";
        button.className = "nx-choice";
        button.textContent = item.label;
        button.addEventListener("click", () => {
          if (isReplying) return;
          row.querySelectorAll("button").forEach((btn) => { btn.disabled = true; });
          if (item.action) {
            item.action();
            return;
          }
          submitMessage(item.message, item.label);
        });
        row.appendChild(button);
      });
      log.appendChild(row);
      log.scrollTop = log.scrollHeight;
    };
    const showCategoryChoices = () => {
      addChoices([
        { label: "桌面灯箱", message: "我想咨询桌面灯箱A3，价格和尺寸" },
        { label: "吊装灯箱", message: "我想咨询吊装灯箱，尺寸和价格" },
        { label: "壁挂灯箱", message: "我想咨询壁挂灯箱，材质尺寸价格" },
        { label: "落地灯箱", message: "我想咨询落地灯箱，推荐和价格" },
        { label: "LED数字屏", message: "我想咨询LED数码屏/LED数字屏，产品链接和价格" },
        { label: "海报框", message: "我想咨询海报框不通电的，尺寸和价格" }
      ]);
    };
    const showScopeChoices = () => {
      addChoices([
        { label: "当前页面产品", message: "我想咨询当前页面这个产品，请先介绍价格和尺寸" },
        {
          label: "其他 NEOX 产品",
          action: () => {
            add("其他 NEOX 产品", "user");
            setTimeout(() => {
              add("好的 ka，您想看哪一类产品？直接点下面分类就可以。", "ai");
              showCategoryChoices();
            }, 260);
          }
        }
      ]);
    };
    const showTyping = () => {
      if (typingNode) return typingNode;
      typingNode = document.createElement("div");
      typingNode.className = "nx-msg nx-ai nx-typing";
      typingNode.setAttribute("aria-live", "polite");
      typingNode.innerHTML = '<span class="nx-dot"></span><span class="nx-dot"></span><span class="nx-dot"></span>';
      log.appendChild(typingNode);
      log.scrollTop = log.scrollHeight;
      return typingNode;
    };
    const hideTyping = () => {
      if (typingNode && typingNode.parentNode) typingNode.parentNode.removeChild(typingNode);
      typingNode = null;
    };
    const typingDelay = (text, index) => {
      const base = index === 0 ? 760 : 620;
      const lengthCost = Math.min(String(text || "").length * 13, 820);
      const jitter = Math.floor(Math.random() * 260);
      return base + lengthCost + jitter;
    };
    const setReplying = (value) => {
      isReplying = value;
      input.disabled = value;
      if (sendButton) sendButton.disabled = value;
    };
    const deliverReplies = (replies) => {
      let index = 0;
      const next = () => {
        if (index >= replies.length) {
          hideTyping();
          setReplying(false);
          return;
        }
        showTyping();
        const reply = replies[index];
        setTimeout(() => {
          hideTyping();
          add(reply, "ai");
          index += 1;
          if (index < replies.length) setTimeout(next, 220 + Math.floor(Math.random() * 180));
          else setReplying(false);
        }, typingDelay(reply, index));
      };
      if (!replies.length) {
        setReplying(false);
        return;
      }
      next();
    };
    const greet = () => {
      if (log.children.length) return;
      add(["Hallo kaka", "Halo ka, admin NEOX di sini", "Siang ka, saya bantu ya"][Math.floor(Math.random() * 3)], "ai");
      setTimeout(() => {
        add(["Boleh langsung tanya harga, ukuran, bahan, cetak poster, atau ongkir ya ka.", "Kaka bisa tanya fabric light box ini, atau produk lain seperti wall, hanging, desktop, LED digital, dan poster frame.", "Kalau sudah ada ukuran, lokasi kirim, atau tipe produk yang dicari, langsung sebutkan saja ka."][Math.floor(Math.random() * 3)], "ai");
        setTimeout(showScopeChoices, 260);
      }, 350);
    };
    const submitMessage = (message, displayMessage) => {
      if (!message) return;
      if (isReplying) return;
      setReplying(true);
      add(displayMessage || message, "user");
      input.value = "";
      setTimeout(showTyping, 180);
      fetchBackendAnswer(message).then((data) => {
        deliverReplies(data && data.replies ? data.replies : answer(message));
      });
    };

    launch.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      postEvent("chat_open", { fallback: true });
      launch.style.setProperty("display", "none", "important");
      panel.style.setProperty("display", "block", "important");
      greet();
    }, true);
    if (close) close.addEventListener("click", () => {
      panel.style.setProperty("display", "none", "important");
      launch.style.setProperty("display", "flex", "important");
    });
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      const message = input.value.trim();
      submitMessage(message);
    }, true);
    root.querySelectorAll("[data-q]").forEach((button) => {
      button.addEventListener("click", () => {
        input.value = button.getAttribute("data-q") || "";
        form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
      });
    });
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", mountFallback);
  else mountFallback();
  setTimeout(mountFallback, 800);
  setTimeout(mountFallback, 2400);
  setTimeout(mountFallback, 5200);
  setTimeout(mountFallback, 9000);
  const takeoverTimer = setInterval(mountFallback, 1600);
  setTimeout(() => clearInterval(takeoverTimer), 18000);
})();
